import React from "react";
import { Link } from "react-router-dom";
import { portfolio } from "../../data/SiteData";
function Portfolio(props) {
  return (
    <section id="portfolio" class="portfolio">
      <div class="container">
        <div class="section-title">
          <span>Portfolio</span>
          <h2>Portfolio</h2>
          <p>
            Projects that{" "}
            <a href="#" style={{ color: "#cc1616" }}>
              Black Box Software Solutions
            </a>{" "}
            took part in
          </p>
        </div>

        <div class="row" data-aos="fade-up">
          <div class="col-lg-12 d-flex justify-content-center">
            <ul id="portfolio-flters">
              <li data-filter="*" class="filter-active">
                All
              </li>
              <li data-filter=".filter-app">App</li>
              <li data-filter=".filter-card">Card</li>
              <li data-filter=".filter-web">Web</li>
            </ul>
          </div>
        </div>

        <div
          class="row portfolio-container"
          data-aos="fade-up"
          data-aos-delay="150"
        >
          {portfolio.map((item) => {
            return (
              <div class={item.filter}>
                <img src={item.image} class="img-fluid" alt="" />
                <div class="portfolio-info">
                  <h4>{item.title}</h4>
                  <p>{item.subTitle}</p>
                  <a
                    href={item.image}
                    data-gallery="portfolioGallery"
                    class="portfolio-lightbox preview-link"
                    title={item.title}
                  >
                    <i class="bx bx-plus"></i>
                  </a>
                  <a
                    href="/portfolio-detailed.html"
                    class="details-link"
                    title="More Details"
                  >
                    <i class="bx bx-link"></i>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
